import type { CSSProperties } from "react";

import { styled } from "simplydo/react/styled";

const Cover = styled.div<{ $image?: string }>`
  width: ${({ theme }) => (theme.sizes.isMobile ? 100 : 168)}px;
  height: ${({ theme }) => (theme.sizes.isMobile ? 100 : 168)}px;
  flex: none;
  margin-left: 2rem;
  border-radius: 16px;
  border: 4px solid #ffffff;
  box-shadow: 0 4px 16px rgba(17, 20, 24, 0.12);
  background-color: #d0d5dc;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: ${({ $image }) => ($image ? `url(${$image})` : "none")};
`;

type EntityCoverProps = {
  image?: string | null;
  style?: CSSProperties;
  className?: string;
};

const EntityCover = ({ image, style, className }: EntityCoverProps) => {
  if (!image) return null;
  return <Cover $image={image} style={style} className={className} />;
};

export default EntityCover;
